import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-simple',
  templateUrl: './contact-simple.component.html',
  styleUrls: ['./contact-simple.component.sass']
})
export class ContactSimpleComponent implements OnInit {

  year:any = 2023;

  constructor() { }

  ngOnInit(): void {
    this.year = new Date().getFullYear();
  }

}
